document.addEventListener("DOMContentLoaded", () => {
  const filterLinks = document.querySelectorAll("[data-filter-link]");

  filterLinks.forEach((link) => {
    link.addEventListener("click", async (event) => {
      event.preventDefault();
      const url = new URL(link.href, window.location.origin);

      // Request just the collection section
      url.searchParams.set("section_id", "collection");

      try {
        const response = await fetch(url.toString());
        const html = await response.text();

        // Extract only the section content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newSection = doc.querySelector('[data-section-id="collection"]');

        if (newSection) {
          const target = document.querySelector(
            '[data-section-id="collection"]'
          );
          target.innerHTML = newSection.innerHTML;

          // Optionally update active state on buttons
          filterLinks.forEach((l) => l.classList.remove("active"));
          link.classList.add("active");

          // Update URL without reloading
          history.pushState({}, "", link.href);
        }
        else {
          console.error("Collection section not found in response.");
        }
      } catch (err) {
        console.error("Error updating collection:", err);
      }
    });
  });

  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("filter-checkbox-close")) {
      event.preventDefault();     
      event.stopPropagation();  
      const label = event.target.closest(".filter-label");
      if (!label) return;
      const checkbox = label.querySelector('input[type="checkbox"]');
      if (!checkbox) return;
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

});
